export default {
      id: "arrow-down-usage",
      viewBox: "0 0 15 9",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#arrow-down",
      toString: function () {
        return this.url;
      }
    }